import { render } from "./ReviewUploadedInput.vue?vue&type=template&id=107c12b8"
import script from "./ReviewUploadedInput.vue?vue&type=script&lang=js"
export * from "./ReviewUploadedInput.vue?vue&type=script&lang=js"
script.render = render

export default script